import React from 'react'
import { Link } from 'react-router-dom'
import Button from 'material-ui/Button'
import Grid from 'material-ui/Grid'
import { withStyles } from 'material-ui/styles'
import KeyboardBackspaceIcon from 'material-ui-icons/KeyboardBackspace'

const style = {
  root: {
    flexGrow: 1
  }
}

const Controls = props => {
  const { classes } = props

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} sm={6} lg={3}>
        <Link to='/products'>
          <Button color='primary'>
            <KeyboardBackspaceIcon /> Go Back
          </Button>
        </Link>
      </Grid>
    </Grid>
  )
}

export default withStyles(style)(Controls)



// WEBPACK FOOTER //
// ./src/products/ProductControls.js